import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { PagesHelper } from "../common/PagesHelper";
import { CLinkOwnerResponseDto, DemandSourcesResponseDto, PageName, PlacementResponseDto, ProductsCampaignsDto, ResetPageDto, TrafficSourceResponseDto, UserInfo } from "../utils/types";
import { FiltersHelper } from "../common/FiltersHelper";
import { useRef } from "react";

interface FiltersPanelProps {
  page: PageName;
  currentUser:UserInfo;
  search: (updateHistory?:boolean) => void;
  trafficSourceResponseDto: TrafficSourceResponseDto;
  placementsResponseDto: PlacementResponseDto;
  setPlacementsResponseDto: (placementsResponseDto: PlacementResponseDto) => void;
  placementsIsLoading: boolean;
  setPlacementsIsLoading: (placementsIsLoading:boolean) => void;
  demandSourcesDto?: DemandSourcesResponseDto;
  cLinkOwnerstsIsLoading?: boolean;
  setCLinkOwnersIsLoading?: (cLinkOwnersIsLoading:boolean) => void;
  cLinkOwnersDto?: CLinkOwnerResponseDto;
  setCLinkOwnersDto?: (cLinkOwnersDto:CLinkOwnerResponseDto) => void;
  mostFrequentTags?: string[];
  productsDto?: ProductsCampaignsDto;
  productsIsLoading?: boolean;
  searchProducts?: (query: string) => void;
  campaignsDto?: ProductsCampaignsDto;
  campaignsIsLoading?: boolean;
  searchCampaigns?: (query: string) => void;
}

function FiltersPanel(props: FiltersPanelProps) {
  const { page, currentUser, search, trafficSourceResponseDto, placementsResponseDto, setPlacementsResponseDto, placementsIsLoading, setPlacementsIsLoading, demandSourcesDto, cLinkOwnerstsIsLoading, setCLinkOwnersIsLoading, cLinkOwnersDto, setCLinkOwnersDto, mostFrequentTags, productsDto, productsIsLoading, searchProducts, campaignsDto, campaignsIsLoading, searchCampaigns } = props;

  const trafficSourcesRef = useRef(null);
  const countriesRef = useRef(null);
  const trafficTypesRef = useRef(null);
  const groupByRef = useRef(null);
  const placementsRef = useRef(null);
  const showMonetizableRef = useRef(null);
  const showWithRevenueRef = useRef(null);
  const showWithConversionsRef = useRef(null);
  const productsRef = useRef(null);
  const campaignsRef = useRef(null);
  const demandSourcesRef = useRef(null);
  const cLinksRef = useRef(null);
  const queryFlagsRef = useRef(null);

  function clearAllFilters(){
    const resetPageDto : ResetPageDto = {
      trafficSourcesRef: trafficSourcesRef,
      countriesRef: countriesRef,
      trafficTypesRef: trafficTypesRef,
      groupByRef: groupByRef,
      placementsRef: placementsRef,
      showMonetizableRef: showMonetizableRef,
      showWithRevenueRef: showWithRevenueRef,
      showWithConversionsRef: showWithConversionsRef,
      productsRef: productsRef,
      campaignsRef: campaignsRef,
      demandSourcesRef: demandSourcesRef,
      cLinksRef: cLinksRef,
      queryFlagsRef: queryFlagsRef
    };
    
    PagesHelper.resetFilters(page, resetPageDto, search);
  }

  const getTrafficSourcesCard = () => {
    return FiltersHelper.getTrafficSourcesCard(
            currentUser, 
            page, 
            trafficSourceResponseDto,
            trafficSourcesRef);
  }

  const getDateRangeCard = () => {
    return FiltersHelper.getDateRangeCard(currentUser, page);
  }

  const getCountriesCard = () => {
    return FiltersHelper.getCountriesCard(currentUser, page, countriesRef);
  }

  const getTrafficTypesCard = () => {
    return FiltersHelper.getTrafficTypesCard(currentUser, page, trafficTypesRef);
  }

  const getPublisherPlacementsCard = () => {
    return FiltersHelper.getPublisherPlacementsCard(
            currentUser, 
            page, 
            placementsRef, 
            trafficSourceResponseDto, 
            setPlacementsResponseDto,
            placementsResponseDto,
            placementsIsLoading,
            setPlacementsIsLoading);
    }

  const getGroupByCard = () => {
    return FiltersHelper.getGroupByCard(currentUser, page, groupByRef);
  }
  
  const getProductsCard = () => {
    return FiltersHelper.getProductsCard(currentUser, page, productsRef, productsDto, searchProducts, productsIsLoading);
  }

  const getCampaignsCard = () => {
    return FiltersHelper.getCampaignsCard(currentUser, page, campaignsRef, campaignsDto, searchCampaigns, campaignsIsLoading);
  }

  const getDemandSorucesCard = () => {
    return FiltersHelper.getDemandSourcesCardForProductsPage(currentUser, page, demandSourcesRef, demandSourcesDto);
  }

  const getCLinksCard = () => {
    return FiltersHelper.getCLinkOwnersCard(
            currentUser,
            page,
            cLinksRef,
            cLinkOwnerstsIsLoading,
            setCLinkOwnersIsLoading,
            cLinkOwnersDto,
            setCLinkOwnersDto,
            trafficSourceResponseDto,
            mostFrequentTags);
  }

  const getQueryFlagsCard = () => {
    return FiltersHelper.getQueryFlagsCard(currentUser, page, queryFlagsRef);
  }

  return (
    <>
      <Row>
        <Col xl={4} className="text-center">
      </Col>        
      <Col xl={4} className="text-center">
        <Button style={{ fontSize: 12  }} size="sm" variant="outline-primary" onClick={clearAllFilters}>
          Reset filters  
        </Button>
      </Col>        
        <Col xl={4} className="text-center">
      </Col>
      </Row>
      <Row xl={10} lg={4} md={2}>
        <Col xl={4} className="text-center mb-2">
          {getTrafficSourcesCard()}
        </Col>
        <Col xl={2} className="text-center mb-2">
          {getDateRangeCard()}
        </Col>
        <Col xl={2} className="text-center mb-2">
          {getCountriesCard()}
        </Col>
        <Col xl={2} className="text-center mb-2">
          {getTrafficTypesCard()}
        </Col>
        <Col xl={2} className="text-center mb-2">
          {getGroupByCard()}
        </Col>
        <Col xl={4} className="text-center mb-2">
          {getPublisherPlacementsCard()}
        </Col>
        <Col xl={2} className="text-center mb-2">
          {getProductsCard()}
        </Col>
        <Col xl={3} className="text-center mb-2">
          {getDemandSorucesCard()}
        </Col>
        <Col xl={3} className="text-center mb-2">
          {getCampaignsCard()}
        </Col>
        <Col xl={4} className="text-center mb-2">
          {getCLinksCard()}
        </Col>
        <Col xl={2} className="text-center mb-2">
          {getQueryFlagsCard()}
        </Col>
      </Row>
    </>
  );
}

export default FiltersPanel;
